let url = window.location.protocol + "//" + window.location.host;

// url = "http://cs-mj.iyuhong.com.cn:4235";
// url = ' http://10.100.28.238:8090';

let baseUrl = url + "/mobile" || "http://192.168.210.165:8080/mobile";
let baseUrl_dingCMS = url + "/dingCMS" || "http://192.168.210.165:8080/mobile";
// console.log(url);
var surfix = ".mob";
let baseApi = function(url) {
  return {
    // 登录
    login: url + "/malogin/formLogin" + surfix,
    // 设置密码
    changePassword: url + "/malogin/changePassword" + surfix,
    // 发送验证码
    sendCode: url + "/malogin/sms" + surfix,
    // 发送验证码重置密码
    smsCheck: url + "/malogin/checkSms" + surfix,
    // 注销
    logout: url + "/malogin/loginout" + surfix,
    //获取用户信息
    getUserInfo: url + "/user/info" + surfix,
    // 获取角色列表
    getUserRole: url + "/user/findRoleListByPhone" + surfix,
    // 切换角色
    toggleUserRole: url + "/malogin/switchRoles" + surfix,

    //修改用户信息
    editUserInfo: url + "/simpleuser/commit" + surfix,

    //修改客户信息
    editCustomerInfo: url + "/custlist/editCustomer" + surfix,
    //查询客户信息
    getCustomerInfo: url + "/custlist/mobileCustomer" + surfix,

    //获取合同列表
    getContractList: url + "/contract/list" + surfix,
    //获取合同详情
    getContractDetail: url + "/contract/detail" + surfix,
    //修改合同
    updateContract: url + "/contract/updateContract" + surfix,

    //获取系统消息列表
    getMessageList: url + "/message/list" + surfix,
    //获取未读消息条数
    getMessageSum: url + "/message/sum" + surfix,
    //保存 客户信息
    saveCustomer: url + "/custlist/saveformobile" + surfix,

    //获取工程列表
    getServiceList: url + "/service/page" + surfix,
    // //获取工程详情
    // "getServiceDetail": url + '/service/' + surfix,
    //获取工程 -- 日志
    getServiceLog: url + "/service/log" + surfix,
    //获取施工日历  month = 2018-10
    getServiceCalendar: url + "/service/calendar" + surfix,
    // 是否接受勘察
    isaccept: url + "/service/acceptallot" + surfix,

    //获取订单列表
    getOrderList: url + "/order/page" + surfix,
    // 获取订单详情  -- orderid
    getOrderDetail: url + "/order/detail" + surfix,
    // 获取某工程 -订单数量  -- serviceid
    getOrderNum: url + "/order/count" + surfix,
    // 取消订单
    cancelOrder: url + "/order/cancel" + surfix,

    // 工序列表
    getProcedureList: url + "/service/procedure" + surfix,
    // 工序列表 -- 多工序名称列表
    getProcedureTypeList: url + "/service/type" + surfix,
    // 获取工程状态
    getProcedureState: url + "/service/checksurvey" + surfix,
    // 工序 -- 获取页面参数
    getProcedureView: url + "/formvaluedata/detail" + surfix,
    // 工序 -- 获取详情
    getProcedureDetail: url + "/formvaluedata/all" + surfix,
    // 工序列表  -- 自动保存
    saveProcedure: url + "/formvaluedata/save" + surfix,
    // 工序列表  -- 提交工序  - sid
    commitProcedure: url + "/service/commit" + surfix,
    // 工序权限  - sid
    getProcedureAuth: url + "/service/checkedit" + surfix,
    // 修改 勘察时间
    editSurveydate: url + "/service/changevalue" + surfix,
    // 勘察表 -- 获取用户的简单数据
    getSimpleuser: url + "/service/data" + surfix,

    // 图片上传 token
    getimgtoken: url + "/file/uptoken" + surfix,
    // 图片上传 接口
    qiniuUpload: "http://up-z1.qiniup.com/",
    //七牛图片下载
    qiniuDownload: "http://dmzoss.iyuhong.com.cn/",

    // 套餐 全部列表
    getProductList: url + "/product/listall" + surfix,
    // 套餐 列表 - 筛选 type
    // "getProductListSearch": url + '/product/list' + surfix,
    // 套餐 详情
    getProductDetail: url + "/product/detail" + surfix,
    // 下单
    takeOrder: url + "/order/save" + surfix,
    // 生成报表
    takeReport: url + "/order/report" + surfix,

    //工人信息
    profile: url + "/webconstruction/show",

    test: url + "/order/detail?orderid=3a134429-c19e-48fe-a7c9-a08660283e55",

    //获取原因列表
    getReasonList: url + "/dictionary/page" + surfix,
    //获取note
    getNote: url + "/service/getnote" + surfix,
    //获取codetree
    getCodeTree: url + "/sysCodeTree/queryByCodeTypeAndParentId" + surfix,
    //获取字典列表
    getCodeList: url + "/sysCodeTree/queryByCodeType" + surfix,
    getCode: url + "/sysCode/findByCodeType" + surfix,
    //获取细项
    getServiceItems: url + "/productitemnew/list" + surfix,
    //闭水报单 提交
    closedWaterCustomsSubmit: url + "/open/bishuiapply" + surfix,

    // 获取深度code表
    getOpenCodes: url + "/open/getOpenCodes.do",
    // 再次报单提交
    bishuiapply: url + "/open/bishuiapply.do",
    //pc上传图片
    getOpenQiniuUpToken: url + "/open/getOpenQiniuUpToken.do",

    //获取合同地址
    getContactUrl: url + "/document/findByOrderid" + surfix,
    //获取质保单地址
    getGuarantUrl: url + "doc/docpdf" + surfix,
    //获取当前登录人信息
    getLoginUserDetail: url + "/simpleuser/infowxshow" + surfix,
    //根据ID获取用户信息
    getUserInfoById: url + "/open/userinfobyid" + surfix,
    //根据运营商信息
    getAgentDetail: url + "/open/useragentinfo" + surfix,
    //获取微信参数接口
    getWXPrameter: url + "/open/querySign" + surfix,
    wxsharebaseurl: url + "/#/",
    //留资信息保存
    saveBillDeal: url + "/service/saveBillDeal" + surfix,
    //获取字典列表
    getCodeList: url + "/sysCodeTree/queryByCodeType" + surfix,

    base: baseUrl + "/"
  };
};
let api = {};
api.mobile = baseApi(baseUrl);
api.dingCMS = baseApi(baseUrl_dingCMS);

export default {
  api
};



// WEBPACK FOOTER //
// ./src/comm/api.js